// This icon file is generated automatically.
var PCameraOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.5 2.88h-2.13l-.5-1.42a.5.5 0 00-.47-.33H4.6a.5.5 0 00-.47.33l-.5 1.42H1.5c-.7 0-1.25.55-1.25 1.25v7.12c0 .7.56 1.25 1.25 1.25h11c.7 0 1.25-.56 1.25-1.25V4.12c0-.69-.56-1.25-1.25-1.25zm.13 8.37c0 .07-.06.13-.13.13h-11a.13.13 0 01-.13-.13V4.12c0-.06.06-.12.13-.12h2.92l.26-.75.36-1h3.92l.35 1 .27.75h2.92c.07 0 .13.06.13.13v7.12zM7 5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm0 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z", "fill-rule": "nonzero" } }] }, "name": "p-camera", "theme": "outlined" };
export default PCameraOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCameraOutlined.js
// module id = 3262
// module chunks = 0